import Auth from '@aws-amplify/auth';

export const awsmobile = {
  aws_project_region: process.env.NEXT_PUBLIC_PROJECT_REGION,
  aws_appsync_region: process.env.NEXT_PUBLIC_APPSYNC_REGION,
  aws_appsync_graphqlEndpoint: process.env.NEXT_PUBLIC_APPSYNC_GRAPHQLENDPOINT,
  aws_appsync_authenticationType:
    process.env.NEXT_PUBLIC_APPSYNC_AUTHENTICATIONTYPE,
  Auth: {
    region: process.env.NEXT_PUBLIC_COGNITO_REGION,
    userPoolId: process.env.NEXT_PUBLIC_USER_POOLID,
    userPoolWebClientId: process.env.NEXT_PUBLIC_USER_POOLWEBCLIENTID,
    identityPoolId: process.env.NEXT_PUBLIC_IDENTITY_POOLID,
  },
};

Auth.configure(awsmobile.Auth);
